import React from "react";
import "./Self_Service_tabs.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

function Self_Service_tabs() {
  const navigate = useNavigate(); // initialize navigate

  const menuItems = [
    {
      title: "Deposit Not Received",
      img: "/assets/images/Self_Service_Center/tab_icons/wallet.png",
      linkText: "/account",
    },
    {
      title: "Withdrawal Problem",
      img: "/assets/images/Self_Service_Center/tab_icons/withdraw.png",
      linkText: "/account",
    },
    {
      title: "IFSC Modification",
      img: "/assets/images/Self_Service_Center/tab_icons/IFSC.png",
      linkText: "/account",
    },
    {
      title: "Change Login Password",
      img: "/assets/images/Self_Service_Center/tab_icons/key.png",
      linkText: "/account",
    },
    {
      title: "Change Bank Name",
      img: "/assets/images/Self_Service_Center/tab_icons/banking.png",
      linkText: "/account",
    },
    {
      title: "Modify Bank Information",
      img: "/assets/images/Self_Service_Center/tab_icons/banking.png",
      linkText: "/account",
    },
    {
      title: "Modify UPI",
      img: "/assets/images/Self_Service_Center/tab_icons/upi.png",
      linkText: "/account",
    },
    {
      title: "Add USDT Address",
      img: "/assets/images/Self_Service_Center/tab_icons/usdt.png",
      linkText: "/account",
    },
    {
      title: "Change USDT Address",
      img: "/assets/images/Self_Service_Center/tab_icons/usdt.png",
      linkText: "/account",
    },
    {
      title: "Activity Bonus",
      img: "/assets/images/Self_Service_Center/tab_icons/surpise.png",
      linkText: "/account",
    },
    {
      title: "Money King Official Website",
      img: "/assets/images/Self_Service_Center/tab_icons/telegram.png",
      linkText: "/account",
    },
  ];

  const handleNavigate = (link) => {
    if (link) {
      navigate(link);
    }
  };

  return (
    <section className="Self_Service_tabs">
      <div className="self_service_container">
        <h3 className="self_service_title">Self Service</h3>

        <div className="self_service_card">
          {menuItems.map((item, index) => (
            <div className="self_service_row" key={index}>
              <div
                className="left_section"
                onClick={() => handleNavigate(item.linkText)}
              >
                <div className="img_holder">
                  <img src={item.img} alt={item.title} className="img_icon" />
                </div>
                <span>{item.title}</span>
              </div>

              <FontAwesomeIcon icon={faChevronRight} className="arrow_icon" />
            </div>
          ))}
        </div>

        <div className="kind_tips">
          <h4>Kind Tips</h4>
          <p>
            1. Please select the corresponding question & submit it for review.
            After successful submission, the customer service specialist will
            handle it for you immediately. Please wait patiently.
          </p>
          <p>
            2. After submitting for review, you can use [Progress Query] to view
            the review results of the work order you submitted.
          </p>
        </div>

        <button className="btn_register_bg">Progress Query</button>
      </div>
    </section>
  );
}

export default Self_Service_tabs;
